import UnfinishedTestCaseExecutions from './UnfinishedTestCaseExecutions';
import { UnfinishedTestCaseExecutionsTableRowProps } from './UnfinishedTestCaseExecutionsTableRow';

export { UnfinishedTestCaseExecutionsTableRowProps };
export default UnfinishedTestCaseExecutions;
